import React, { useState, useEffect } from 'react';
import mockupImage from '../../assets/images/MOCKUPS (1).png';
import qrCodeImage from '../../assets/images/qrcode_play.google.com.png';

const PlayStoreIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
  </svg>
);

const AppleIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

export default function AppDownloadSection() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [playHover, setPlayHover] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
      setIsMobile(window.innerWidth < 640);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap');

        .ads * { box-sizing: border-box; }

        .ads {
          width: 100%;
          background: #08090f;
          padding: ${isDesktop ? '72px 0' : '56px 0'};
          font-family: 'DM Sans', sans-serif;
        }

        .ads-container {
          max-width: 1080px;
          margin: 0 auto;
          padding: 0 40px;
          display: flex;
          flex-direction: ${isDesktop ? 'row' : 'column-reverse'};
          align-items: center;
          gap: ${isDesktop ? '80px' : '40px'};
        }

        /* Image */
        .ads-image {
          flex: 1.1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .ads-image img {
          width: 100%;
          max-width: ${isDesktop ? '520px' : '380px'};
          height: auto;
          object-fit: contain;
          filter: drop-shadow(0 24px 48px rgba(0,0,0,0.6));
          transform: ${isDesktop ? 'scale(1.15)' : 'none'};
        }

        /* Content */
        .ads-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: ${isDesktop ? 'flex-start' : 'center'};
          text-align: ${isDesktop ? 'left' : 'center'};
        }

        .ads-pill {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          background: rgba(253,214,73,0.08);
          border: 1px solid rgba(253,214,73,0.2);
          border-radius: 999px;
          color: #fdd649;
          font-size: 0.72rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1.4px;
          padding: 6px 16px;
          margin-bottom: 20px;
        }
        .ads-pill-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #fdd649;
        }

        .ads-heading {
          font-family: 'Syne', sans-serif;
          color: #ffffff;
          font-size: ${isDesktop ? '2.6rem' : '2rem'};
          font-weight: 800;
          line-height: 1.15;
          letter-spacing: -0.5px;
          margin: 0 0 12px 0;
        }
        .ads-heading span { color: #fdd649; }

        .ads-desc {
          font-size: 0.97rem;
          color: #7c829a;
          line-height: 1.7;
          margin: 0 0 32px 0;
          max-width: 400px;
        }

        /* Download row */
        .ads-download {
          display: flex;
          flex-direction: ${isMobile ? 'column' : 'row'};
          align-items: center;
          gap: 20px;
          width: 100%;
        }

        /* QR */
        .ads-qr {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          flex-shrink: 0;
        }
        .ads-qr-img {
          background: #ffffff;
          padding: 10px;
          border-radius: 14px;
          width: 110px;
          height: 110px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ads-qr-img img {
          width: 90px;
          height: 90px;
          display: block;
        }
        .ads-qr-label {
          font-size: 0.68rem;
          color: #555a72;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* Divider */
        .ads-sep {
          width: ${isMobile ? '100%' : '1px'};
          height: ${isMobile ? '1px' : '80px'};
          background: rgba(255,255,255,0.08);
          flex-shrink: 0;
        }

        /* Buttons */
        .ads-buttons {
          display: flex;
          flex-direction: column;
          gap: 10px;
          flex: 1;
          width: ${isMobile ? '100%' : 'auto'};
          min-width: 200px;
        }

        .ads-btn-play {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 13px 22px;
          border-radius: 12px;
          background: #fdd649;
          color: #0a0c16;
          font-family: 'DM Sans', sans-serif;
          font-weight: 700;
          font-size: 0.9rem;
          text-decoration: none;
          border: none;
          cursor: pointer;
          width: 100%;
          justify-content: center;
          transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
          background: ${playHover ? '#ffe566' : '#fdd649'};
          transform: ${playHover ? 'translateY(-1px)' : 'none'};
          box-shadow: ${playHover ? '0 6px 20px rgba(253,214,73,0.3)' : '0 2px 10px rgba(253,214,73,0.15)'};
        }
        .ads-btn-text { display: flex; flex-direction: column; align-items: flex-start; line-height: 1.25; }
        .ads-btn-sub { font-size: 0.65rem; font-weight: 500; opacity: 0.65; text-transform: uppercase; letter-spacing: 0.7px; }
        .ads-btn-main { font-size: 0.92rem; font-weight: 700; }

        .ads-btn-apple {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 13px 22px;
          border-radius: 12px;
          background: transparent;
          border: 1px solid rgba(255,255,255,0.1);
          color: #45495e;
          font-family: 'DM Sans', sans-serif;
          font-weight: 600;
          font-size: 0.9rem;
          cursor: not-allowed;
          width: 100%;
          justify-content: center;
        }
        .ads-btn-apple .ads-btn-sub,
        .ads-btn-apple .ads-btn-main { color: #45495e; }
      `}</style>

      <section className="ads">
        <div className="ads-container">

          {/* Image */}
          <div className="ads-image">
            <img src={mockupImage} alt="SkillServe App Mockup" />
          </div>

          {/* Content */}
          <div className="ads-content">

            <div className="ads-pill">
              <span className="ads-pill-dot" />
              Mobile App
            </div>

            <h2 className="ads-heading">
              Learn Anywhere,<br /><span>On Any Device.</span>
            </h2>

            <p className="ads-desc">
              Access your courses, track progress, and attend live classes — right from your phone.
            </p>

            <div className="ads-download">

              <div className="ads-qr">
                <div className="ads-qr-img">
                  <img src={qrCodeImage} alt="Scan to Download" />
                </div>
                <span className="ads-qr-label">Scan to Download</span>
              </div>

              <div className="ads-sep" />

              <div className="ads-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.skillserve.lmsapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ads-btn-play"
                  onMouseEnter={() => setPlayHover(true)}
                  onMouseLeave={() => setPlayHover(false)}
                >
                  <PlayStoreIcon />
                  <div className="ads-btn-text">
                    <span className="ads-btn-sub">Get it on</span>
                    <span className="ads-btn-main">Google Play</span>
                  </div>
                </a>

                <button className="ads-btn-apple" disabled>
                  <AppleIcon />
                  <div className="ads-btn-text">
                    <span className="ads-btn-sub">Coming Soon</span>
                    <span className="ads-btn-main">App Store</span>
                  </div>
                </button>
              </div>

            </div>
          </div>

        </div>
      </section>
    </>
  );
}